export default {
  title: 'My DashBoard',
  menu: 'Dashboard',
  label: {
    jobShares: 'Job Shares',
    pageViews: 'Page Views',
    referrals: 'Referrals',
    referJobs: 'Refer jobs',
    referRules: 'Referral Rules/Policies',
    referFAQ: 'Referral FAQ',
    referJobsText: 'Share jobs with your network',
    myDashboard: 'Dashboard',
    views: 'Views',
    leads: 'Leads',
    resumeSubmit: 'Resume Submitted',
    recommendPositions: 'Recommend Positions',
    positionTip: 'Share posts to your circles',
    recommendRules: 'Recommend Rules/Policies',
    recommendFAQ: 'Recommend FAQ'
  },
  potentialStatus: {
    leads: 'Leads',
    prospects: 'Prospects',
    submitReferrals: 'Submit Referrals'
  }
}
